import {isTerm100Policy, isTermPolicy, isWholeLifePolicy} from 'custom/common/report/constants';
import {calcAgeNearest} from 'custom/common/utils/lookupFunctions';
import {firstYearPremium} from '../redux/reducers';

export const initialFormData = {
  formName: "ProQuote",
  current: "personal",
  txtProquoteFirstName: "",
  txtProquoteLastName: "",
  txtProquoteFullName: "",
  txtProquoteEmail: "",
  txtProquotePhone: "",
  rdoProquoteGender: "",
  dtProquoteDob: new Date(),
  rdoProquoteSmokeClass: "",
  rdoProquoteHealthMatch: "S",
  // cboProquoteProduct: '0131',
  rdoProquoteTermPolicy: "",
  rdoProquoteWLPolicy: "",
  txtProquoteProduct: "",
  txtProquoteFaceAmount: "250000",
  rdoProquotePaymentFrequency: "",
  rdoProquoteDividendOption: "NONE",
  rdoProquotePremiumOffset: "",
  btnProquoteSkip: false,
  rdoProquoteWaiver: "",
  // cboProquoteWaiverRating: '100',
  rdoProquoteADB: "",
  txtProquoteADBAmount: "100000",
  // cboProquoteADBRating: '100',
  rdoProquoteCPB: "",
  txtProquoteCPBAmount: "25000",
  rdoProquoteGPO: "",
  txtProquoteGPOAmount: "50000",
  rdoProquoteWPD: "",
  rdoProquoteAIB: "",
  txtProquoteAIBOwnerAge: "40",
  btnProquoteViewQuote: "",
  cboProquoteProvince: "",
  txtProQuotePageNumber: "1",
  chkProQuoteCASL: false,
  rdoProquoteLeadSource: "",
  fintel_click_id: "",
  productid: "",
  utm_campaign: "",
  utm_source: "",
  utm_medium: "",
  utm_term: "",
  utm_content: "",
};

// export const buildProductOptionItems = (interfaceSetupArray, age) => {
//   let optionsProduct = {};

//   if (!interfaceSetupArray) {
//     return optionsProduct;
//   }
//   for (let item of interfaceSetupArray) {
//     if (item.isDisplayed && item.policyType !== 'UL') {
//       if (age >= item.ageMin && age <= item.ageMax) {
//         optionsProduct[`0${item.prodID}`] = item.prodName;
//       }
//     }
//   }
//   return optionsProduct;
// };
export const buildProductOptionItems = (interfaceSetupArray, age) => {
  let termOptions = {};
  let wlOptions = {};

  if (!interfaceSetupArray) {
    return {termOptions, wlOptions};
  }
  for (let item of interfaceSetupArray) {
    // if (item.isDisplayed && item.policyType !== 'UL') {
    if (age >= item.ageMin && age <= item.ageMax) {
      if (isTerm100Policy(`0${item.prodID}`) || isTermPolicy(`0${item.prodID}`)) {
        termOptions[`0${item.prodID}`] = item.displayName;
      } else if (isWholeLifePolicy(`0${item.prodID}`)) {
        wlOptions[`0${item.prodID}`] = item.displayName;
      }
      // }
    }
  }
  return {termOptions, wlOptions};
};

export const getAgeInYears = (dob, today) => {
  const yearDiff = today.getFullYear() - dob.getFullYear();
  const monthDiff = today.getMonth() - dob.getMonth();
  const dateDiff = today.getDate() - dob.getDate();

  const age = yearDiff + (monthDiff < 0 ? -1 : monthDiff === 0 ? (dateDiff < 0 ? -1 : 0) : 0);
  return age;
};

export const calcDataGenerator = (formData) => {
  let calcData = {
    formName: 'ProQuote',
    cboSelectUser: 'All',
    cboProduct: '0602',
    cboProductID: 602,
    cboPaymentMode: '012',
    txtFaceAmount: '250000',
    txtOwnerName: '',
    txtInsuredName: '',
    txtAge: '40',
    cboSex: 'M',
    cboSmokeClass: 'N',
    cboRateClass: 'S',
    chkRatings: false,
    cboRating: '100',
    txtFlatExtra: '0',
    txtFlatExtraDuration: '0',
    txtInsuredName2: '',
    txtAge2: '40',
    cboSex2: 'M',
    cboSmokeClass2: 'N',
    cboRateClass2: 'S',
    chkRatings2: false,
    txtRatedESA: '40',
    txtCalculatedESA: '40',
    jointAgeMin: '25',
    jointAgeMax: '80',
    chkWaiver: false,
    cboWaiverRating: '100',
    chkADB: false,
    txtADBAmount: '100000',
    cboADBRating: '100',
    chkCPB: false,
    txtCPBAmount: '25000',
    chkWPD: false,
    cboWPDRating: '100',
    chkGPO: false,
    txtGPOAmount: '50000',
    cboGPORating: '100',
    chkAIB: false,
    txtAIBOwnerAge: '20',
    cboAIBRating: '100',
    btnPremium: '',
    btnFullPremium: '',
    CurrentField: 'cboProduct', //The CurrentField should be set on GetFocus and unset on LostFocus as the StatusDisplay uses this to know which field to get the status for. Though initialized with a custom value on first load Status setting
    numErrors: 0,
    rdoDuration: 'All',
    chkCoverPage: true,
    chkTaxPage: false,
    chkUnderwritingPage: false,
    chkComplianceNotice: false,
    chkProductCompare: false,
    isRunCompare: false,
    chkInternalRoR: false,
    chkCharitableGiving: false,
    chkInsuranceInvestment: false,
    chkSharedOwnership: false,
    txtCharitableGivingIntRate: '1',
    txtCharitableGivingTaxRate: '40.16',
    txtInsuranceInvestmentIntRate: '1',
    txtInsuranceInvestmentTaxRate: '40.16',
    cboSelectedYears: '5',
    cboIntervalYears: '2',
    cboPolicyType: 'SINGLE',
    chkPremiumOffsetIllustration: false,
    txtPy1: '10',
    txtPy2: '20',
    txtPy3: '0',
    txtPy4: '0',
    txtPy5: '0',
    txtAgeD1: '65',
    txtAgeD2: '85',
    txtAgeD3: '100',
    txtAgeD4: '0',
    txtAgeD5: '0',
    switchInforce: '',
    lblPremium: 'Not Applicable',
    cboDividendOption: 'NONE',
    cboDeathBenefitType: 'LF',
    cboCOIType: 'L',
    txtTargetAccountValue1: '10000',
    txtTargetYear1: '60',
    cboDepositType: 'S',
    cboFaceAmountType: 'S',
    txtDepositAmount: '720',
    txtDepositDuration: '60',
    txtTargetAccountValue2: '10000',
    txtTargetYear2: '60',
    chkFundSelection1: false,
    cboFundSelection1: 'DI',
    txtFundSelectionInterestRate1: '1.25',
    txtFundSelectionAllocationPercent1: '100',
    chkFundSelection2: false,
    cboFundSelection2: 'CBF',
    txtFundSelectionInterestRate2: '1.50',
    txtFundSelectionAllocationPercent2: '0',
    chkFundSelection3: false,
    cboFundSelection3: 'CEFI',
    txtFundSelectionInterestRate3: '5.95',
    txtFundSelectionAllocationPercent3: '0',
    chkFundSelection4: false,
    cboFundSelection4: 'APEF',
    txtFundSelectionInterestRate4: '4.15',
    txtFundSelectionAllocationPercent4: '0',
    isSummaryDirty: true,
    txtEmployerBenefitPeriod: '60',
    txtEmployerPayPeriod: '25',
    isSharedOwnership: false,
    isRunningBatch: false,
    txtFaceAmountSolvePremium: '500',
    txtNewBusinessIncomeStartAge: '65',
    txtNewBusinessIncomeEndAge: '100',
    txtNewBusinessIncomeAmount: '1000',
    cboNewBusinessIncomeType: 'N',
    cboNewBusinessIncomeBasis: 'W',
    chkProductCompare: false,
    cboRateClass: 'S',
    chkTerm10: true,
    txtTermFaceAmount10: '250000',
    cboTermDurationType10: 'A',
    txtTermDuration10: '85',
    chkTerm20: false,
    txtTermFaceAmount20: '250000',
    cboTermDurationType20: 'A',
    txtTermDuration20: '85',
    chkTerm30: false,
    txtTermFaceAmount30: '250000',
    cboTermDurationType30: 'A',
    txtTermDuration30: '85',
    chkADO: false,
    txtADOAmount: '120',
    txtADODuration: '60',
    chkPremiumOffsetIllustration: false,
    chkSolveADO: false,
    txtSolvePremiumPUA: '3500',
    txtSolveADOPremiumPUA: '0',
    chkCoveragePage: false,
    chkHealthMatchPage: false,
    chkBenefitsPage: false,
    chkMemberBenefits: true,
    faceSolveType: '0',
    isProductHealthMatch: true,
    isHealthMatch: true,
    rdoPremiumOffset: 'O',
    txtPremiumOffsetYear: '20',
    isAllowDividends: false,
    healthMatchMinFaceAmount: 1000001,
    txtTotalFaceAmount: '250000',
  };
  formData['txtProquoteFullName'] =
    formData['txtProquoteFirstName'] + ' ' + formData['txtProquoteLastName'];
  calcData['txtOwnerName'] = formData['txtProquoteFullName'];
  calcData['txtInsuredName'] = formData['txtProquoteFullName'];

  //Only one of the control value can be set and will be used as product value for calculation.
  calcData['cboProduct'] = formData['rdoProquoteTermPolicy'];
  if (formData['rdoProquoteTermPolicy'] === '') {
    calcData['cboProduct'] = formData['rdoProquoteWLPolicy'];
  }
  calcData['txtFaceAmount'] = formData['txtProquoteFaceAmount'];
  calcData['txtTermFaceAmount10'] = formData['txtProquoteFaceAmount'];
  calcData['txtTermFaceAmount20'] = formData['txtProquoteFaceAmount'];
  calcData['txtTermFaceAmount30'] = formData['txtProquoteFaceAmount'];
  if (isTermPolicy(calcData['cboProduct'])) {
    switch (calcData['cboProduct']) {
      case '0897':
        calcData['chkTerm10'] = true;
        calcData['chkTerm20'] = false;
        calcData['chkTerm30'] = false;
        break;
      case '0898':
        calcData['chkTerm10'] = false;
        calcData['chkTerm20'] = true;
        calcData['chkTerm30'] = false;
        break;
      case '0899':
        calcData['chkTerm10'] = false;
        calcData['chkTerm20'] = false;
        calcData['chkTerm30'] = true;
        break;
      default:
    }
    calcData['txtProduct'] = calcData['cboProduct'];
    calcData['cboProductID'] = 180;
    calcData['cboProduct'] = '0180';
  } else {
    calcData['chkTerm10'] = calcData['chkTerm20'] = calcData['chkTerm30'] = false;
    calcData['txtProduct'] = calcData['cboProduct'];
    calcData['cboProductID'] = parseInt(calcData['cboProduct']);
  }

  calcData['txtAge'] = calcAgeNearest(formData['dtProquoteDob'], new Date()).toString();
  calcData['cboPaymentMode'] = formData['rdoProquotePaymentFrequency'];
  calcData['cboSex'] = formData['rdoProquoteGender'];
  calcData['cboSmokeClass'] = formData['rdoProquoteSmokeClass'] === 'Y' ? 'S' : 'N';
  calcData['cboRateClass'] = formData['rdoProquoteHealthMatch'];
  //We are required to include the health match page if Health Match is not Standard
  if (formData['rdoProquoteHealthMatch'] != 'S') {
    calcData['chkHealthMatchPage'] = true;
  }
  calcData['chkWaiver'] = formData['rdoProquoteWaiver'] === 'ADDED';
  // calcData['cboWaiverRating'] = formData['cboProquoteWaiverRating'];
  calcData['chkADB'] = formData['rdoProquoteADB'] === 'ADDED';
  calcData['txtADBAmount'] = formData['txtProquoteADBAmount'];
  // calcData['cboADBRating'] = formData['cboProquoteADBRating'];
  calcData['chkCPB'] = formData['rdoProquoteCPB'] === 'ADDED';
  calcData['txtCPBAmount'] = formData['txtProquoteCPBAmount'];
  calcData['chkWPD'] = formData['rdoProquoteWPD'] === 'ADDED';
  calcData['chkGPO'] = formData['rdoProquoteGPO'] === 'ADDED';
  calcData['txtGPOAmount'] = formData['txtProquoteGPOAmount'];
  calcData['chkAIB'] = formData['rdoProquoteAIB'] === 'ADDED';
  calcData['txtAIBOwnerAge'] = formData['txtProquoteAIBOwnerAge'];
  calcData['chkGPO'] = formData['rdoProquoteGPO'] === 'ADDED';
  calcData['txtGPOAmount'] = formData['txtProquoteGPOAmount'];

  if (
    calcData['chkWaiver'] == 1 ||
    calcData['chkADB'] == 1 ||
    calcData['chkCPB'] == 1 ||
    calcData['chkWPD'] == 1 ||
    calcData['chkGPO'] == 1 ||
    calcData['chkAIB'] == 1
  ) {
    calcData['chkBenefitsPage'] = true;
  }

  calcData['chkPremiumOffsetIllustration'] = formData['rdoProquotePremiumOffset'] === 'ADDED';
  calcData['cboDividendOption'] = formData['rdoProquoteDividendOption'];
  calcData['chkProQuoteCASL'] = formData['chkProQuoteCASL'];
  return calcData;
};

export const getTerm = (optionText) => {
  if (optionText.includes('Term') && optionText !== 'Term to 100') {
    return `${optionText.slice(4)} years`;
  } else if (optionText === 'Term to 100') {
    return 'To age 100';
  } else {
    return 'For life';
  }
};

export const formatCoverage = (displayValue = "0") => {
  let value = +displayValue;
  if (displayValue < 1000) {
    value = `$${displayValue}`;
  } else if (displayValue < 1000000) {
    value = `$${displayValue / 1000}k`;
  } else if (displayValue >= 1000000) {
    value = `$${displayValue / 1000000}M`;
  }
  return value;
};

export const getModalPremium = (firstYearPremium) => {
  for (let columnItem of firstYearPremium.columnItems) {
    if (columnItem.name === 'ModalPremium') {
      //console.log("FOUND");
      return formatValue(firstYearPremium.dblTableData_Main[1][columnItem.columnNumber]);
    }
  }
};

const formatValue = (n) => {
  return '$' + n.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
};

export const getFrequency = (formData) => {
  if (formData['rdoProquotePaymentFrequency'] === '012') {
    return 'per year';
  } else if (formData['rdoProquotePaymentFrequency'] === '06') {
    return 'semi-annually';
  } else if (formData['rdoProquotePaymentFrequency'] === '03') {
    return 'per quarter';
  } else if (formData['rdoProquotePaymentFrequency'] === '01') {
    return 'per month';
  }
};

export const populateBenefits = (age, interfaceSetupItems) => {
  let benefits = [];
  if (interfaceSetupItems) {
    if (
      interfaceSetupItems['isAllowWaiver'] === true &&
      age >= interfaceSetupItems['waiverAgeMin'] &&
      age <= interfaceSetupItems['waiverAgeMax']
    ) {
      benefits.push('DPW');
    }
    if (
      interfaceSetupItems['isAllowADB'] === true &&
      age >= interfaceSetupItems['adbAgeMin'] &&
      age <= interfaceSetupItems['adbAgeMax']
    ) {
      benefits.push('ADB');
    }
    if (
      interfaceSetupItems['isAllowGPO'] === true &&
      age >= interfaceSetupItems['gpoAgeMin'] &&
      age <= interfaceSetupItems['gpoAgeMax']
    ) {
      benefits.push('GPO');
    }
    if (
      interfaceSetupItems['isAllowAIB'] === true &&
      age >= interfaceSetupItems['aibAgeMin'] &&
      age <= interfaceSetupItems['aibAgeMax']
    ) {
      benefits.push('AIB');
    }
    if (
      interfaceSetupItems['isAllowCPB'] === true &&
      age >= interfaceSetupItems['cpbAgeMin'] &&
      age <= interfaceSetupItems['cpbAgeMax']
    ) {
      benefits.push('Child Protector');
    }
  }
  return benefits;
};
